
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage } from "element-plus";
import { Loading } from "@element-plus/icons-vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  components: { Loading },

  setup() {
    const loading = ref(true);
    const lifting = ref(false);
    const paused = ref(false);
    const ttlSeconds = ref(-2);
    let pollTimer: ReturnType<typeof setInterval> | null = null;
    let countdownTimer: ReturnType<typeof setInterval> | null = null;

    const ttlDisplay = computed(() => {
      const s = ttlSeconds.value;
      if (s <= 0) return "即将";
      const m = Math.floor(s / 60);
      const sec = s % 60;
      return m > 0 ? `${m} 分 ${sec} 秒` : `${sec} 秒`;
    });

    const startCountdown = () => {
      if (countdownTimer) clearInterval(countdownTimer);
      countdownTimer = setInterval(() => {
        if (ttlSeconds.value > 0) {
          ttlSeconds.value -= 1;
        }
      }, 1000);
    };

    const fetchStatus = () => {
      loading.value = true;
      ApiService.setHeader();
      ApiService.get("admin/settlements", "pause_status")
        .then(({ data }) => {
          paused.value = data.data?.paused ?? false;
          ttlSeconds.value = data.data?.ttl_seconds ?? -2;
          if (paused.value) {
            startCountdown();
          } else if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
          }
        })
        .catch(() => {
          ElMessage.error("查询暂停状态失败");
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const liftPause = () => {
      lifting.value = true;
      ApiService.setHeader();
      ApiService.post("admin/settlements/lift_pause", {})
        .then(({ data }) => {
          ElMessage.success(data.message || "已解除暂停");
          fetchStatus();
        })
        .catch(() => {
          ElMessage.error("解除暂停失败，请重试");
        })
        .finally(() => {
          lifting.value = false;
        });
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs("结算暂停管理", ["系统设置"]);
      fetchStatus();
      // 每 30 秒自动刷新
      pollTimer = setInterval(fetchStatus, 30000);
    });

    onUnmounted(() => {
      if (pollTimer) clearInterval(pollTimer);
      if (countdownTimer) clearInterval(countdownTimer);
    });

    return { loading, lifting, paused, ttlSeconds, ttlDisplay, fetchStatus, liftPause };
  },
});
